import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputStyled = styled.input`
  background-color: #f5f8fa;
  height: 100%;
  border: none;
  border-radius: 50px;
  padding: 12px 35px 12px 16px;
  outline: none;
  width: 100%;
  font-family: "Roboto";
  font-size: 1rem;
`;

export const Icon = styled.i`
  position: absolute;
  right: 14px;
`;
